import { jsPDF } from 'jspdf';

const STATUS_LABELS = {
  PENDENTE: 'Pendente',
  AUTORIZADO: 'Autorizado',
  NEGADO: 'Negado',
};

function escapeCsv(value) {
  const s = String(value ?? '');
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

function formatDateTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return `${date.toLocaleDateString('pt-BR')} ${date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
}

function rowData(a) {
  return {
    processo: a.processoCodigo || a.processoId || '',
    titulo: a.titulo || a.solicitacaoTitulo || '',
    tipo: a.tipo === 'PROCESSO_PAGAMENTO' ? 'Pagamento' : 'Contratação',
    destino: a.destinoLabel || a.destino || '',
    status: STATUS_LABELS[a.status] || a.status || '',
    processoStatus: a.processoStatus || '',
    criadoEm: formatDateTime(a.criadoEm),
  };
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

export function exportAtividadesExcel(atividades, { label = 'Atividades' } = {}) {
  const rows = (atividades || []).map(rowData);
  const headers = ['Processo', 'Título', 'Tipo', 'Destino', 'Status', 'Status processo', 'Criado em'];
  const lines = [
    headers.join(','),
    ...rows.map((r) =>
      [r.processo, r.titulo, r.tipo, r.destino, r.status, r.processoStatus, r.criadoEm].map(escapeCsv).join(',')
    ),
  ];
  const csv = `\uFEFF${lines.join('\r\n')}`;
  const safe = String(label || 'Atividades').replace(/[<>:"/\\|?*]/g, '_');
  const stamp = new Date().toISOString().slice(0, 10);
  downloadBlob(new Blob([csv], { type: 'text/csv;charset=utf-8;' }), `atividades_${safe}_${stamp}.csv`);
  return rows.length;
}

export function exportAtividadesPdf(atividades, { label = 'Atividades', unidade = '' } = {}) {
  const rows = (atividades || []).map(rowData);
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const margin = 10;
  let y = 14;

  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text(`Atividades — ${label}`, margin, y);
  y += 6;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  const meta = [
    unidade ? `Unidade: ${unidade}` : null,
    `Gerado em: ${new Date().toLocaleString('pt-BR')}`,
    `Registros: ${rows.length}`,
  ]
    .filter(Boolean)
    .join('  ·  ');
  doc.text(meta, margin, y);
  y += 8;

  const cols = [
    { key: 'processo', label: 'Processo', w: 32 },
    { key: 'titulo', label: 'Título', w: 60 },
    { key: 'tipo', label: 'Tipo', w: 28 },
    { key: 'destino', label: 'Destino', w: 40 },
    { key: 'status', label: 'Status', w: 28 },
    { key: 'processoStatus', label: 'Proc.', w: 28 },
    { key: 'criadoEm', label: 'Criado em', w: 36 },
  ];

  const drawHeader = () => {
    doc.setFillColor(227, 242, 253);
    doc.rect(margin, y - 4, 277, 7, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    let x = margin;
    cols.forEach((c) => {
      doc.text(c.label, x + 1, y);
      x += c.w;
    });
    y += 6;
    doc.setFont('helvetica', 'normal');
  };

  drawHeader();
  rows.forEach((r, idx) => {
    if (y > 190) {
      doc.addPage();
      y = 14;
      drawHeader();
    }
    if (idx % 2 === 0) {
      doc.setFillColor(248, 250, 255);
      doc.rect(margin, y - 3.5, 277, 6.5, 'F');
    }
    let x = margin;
    cols.forEach((c) => {
      const text = String(r[c.key] || '—');
      const clipped = doc.splitTextToSize(text, c.w - 2)[0] || '—';
      doc.text(clipped, x + 1, y);
      x += c.w;
    });
    y += 6.5;
  });

  if (!rows.length) {
    doc.setFontSize(10);
    doc.text('Nenhum registro para exportar.', margin, y + 4);
  }

  const safe = String(label || 'Atividades').replace(/[<>:"/\\|?*]/g, '_');
  const stamp = new Date().toISOString().slice(0, 10);
  doc.save(`atividades_${safe}_${stamp}.pdf`);
  return rows.length;
}
